import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

import '../node_modules/material-components-web/dist/material-components-web.min.css';
import './index.css';

ReactDOM.render(<App />, document.getElementById('root'));